// Module
var code = "<script>let $ctrl</script> <molecule-form-edit> <molecule-panel-error error-type=\"general\" error-box-type=\"fixed\"></molecule-panel-error> <organ-edit-panel-machine-upgrade machine=\"$ctrl.machine\"></organ-edit-panel-machine-upgrade> </molecule-form-edit> ";
// Exports
module.exports = code;